<!-- Fixed rail width: the svg now scales to 100% of this box (see renderFlowSummary's viewBox fit), so the
     container must carry the width the svg used to provide, otherwise the left card would collapse. -->
<div id="flow-summary-view" style="width: 290px;"></div>
